export default __webpack_public_path__ + "graphics/parlor-social-club.0d616287.svg";